import { useEffect, useState } from "react";
import { getContentDetail } from "../service";
import { useNavigate } from "react-router-dom";
import { Divider, Skeleton } from "antd";
import { trackZymedEvent, ZYMED_EVENTS } from "../../../utils/zymedAnalytics";

const InProgressQuizCard = ({ quiz, contentTypes, token, tab }: any) => {
    const navigate = useNavigate();
    const [contentDetails, setContentDetails] = useState<any>(null);
    const fetchContentDetails = async () => {
        const res: any = await getContentDetail(quiz?.contentId, token);
        if (res !== undefined) {
            console.log("content details {}", res);
            setContentDetails(res);
        }
    }

    useEffect(() => {
        if (quiz)
            fetchContentDetails();
    }, []);


    function handleQuizClick() {
        if (tab === "finished") {
            trackZymedEvent(ZYMED_EVENTS.PEDIA_FINISHED_QUIZ_RESULT_REOPENED, {
                quiz_id: quiz?.id,
            });
        }
        navigate(tab === 'in-progress' ? `/tatvapedia/quiz?contentInfoId=${quiz?.contentId}` : `/tatvapedia/quiz-result?contentInfoId=${quiz?.contentId}&quizId=${quiz?.id}&userInfoId=${quiz?.userInfoId}&backTo=quiz-list`);
    }

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleDateString('en-GB', { month: 'short' });
        const year = date.getFullYear();
        
        // Add ordinal suffix to day
        const getOrdinalSuffix = (day: number) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };
        
        return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    };

    return (<div className="bg-white rounded-lg shadow-md p-4 w-full max-w-md">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
            <div>
                <p className="text-xs font-semibold text-yellow-600 uppercase tracking-wide">
                    {contentDetails?.consolidatedModule[0]?.toUpperCase()}
                </p>
                <h2 className="text-md font-bold min-w-25 text-gray-800 mt-2 line-clamp-2">
                    {quiz?.title}
                </h2>
                {tab === 'in-progress' && <p className="text-xs text-gray-500 mt-5">
                    Expires on: {formatDate(quiz?.endDate)}
                </p>}
                {tab === 'finished' && <p className="text-xs text-gray-500 mt-5">
                    Completed on: {formatDate(quiz?.filledAt)}
                </p>}

            </div>
            {contentDetails?.uploadThumbnailUrl ? (
                <img
                    src={contentDetails.uploadThumbnailUrl}
                    alt="Speaker"
                    className="w-32 h-32 max-w-40 max-h-28 min-w-32 object-cover rounded-md md:w-52 md:h-52 lg:w-64 lg:h-64"
                />
            ) : (
                <Skeleton.Image
                    active
                    style={{ width: '100%', height: '100%' }}
                    className="w-32 h-32 max-w-40 max-h-28 min-w-32 md:w-52 md:h-52 lg:w-64 lg:h-64 rounded-md"
                />
            )}
        </div>

        {/* Button */}
        <button
            onClick={handleQuizClick}
            className={`w-full py-3  font-semibold rounded-xl transition duration-200
    ${tab === 'in-progress'
                    ? 'bg-[#4b4ad5] text-white'     // Color for 'in-progress' tab
                    : 'bg-[#fff] text-[#4b4ad5] border-[1px]  border-[#4b4ad5]'     // Color for other tabs (e.g., 'completed')
                }
  `}
        >
            {tab === 'in-progress' ? 'Start Quiz' : 'View Result'}
        </button>
    </div>);
};

export default InProgressQuizCard;